// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/fss-aerodrome-advisory-service.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/fss-aerodrome-advisory-service/fss-aerodrome-advisory-service.js';

mount([g0]);
